
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("f7Vk9", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable jsdoc/check-tag-names */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $42omo = parcelRequire("42omo");


var $hpUsb = parcelRequire("hpUsb");

var $9ISlX = parcelRequire("9ISlX");


var $9CM6e = parcelRequire("9CM6e");


var $eIleF = parcelRequire("eIleF");


var $6CRn4 = parcelRequire("6CRn4");

var $iq4lN = parcelRequire("iq4lN");

var $bWRlG = parcelRequire("bWRlG");


var $aFUXX = parcelRequire("aFUXX");


var $dh538 = parcelRequire("dh538");


var $9JpPs = parcelRequire("9JpPs");


var $iu6m9 = parcelRequire("iu6m9");


var $eIPRD = parcelRequire("eIPRD");


var $1zvWv = parcelRequire("1zvWv");


var $3jBhR = parcelRequire("3jBhR");


var $bYRk6 = parcelRequire("bYRk6");


var $eauJy = parcelRequire("eauJy");


var $eQ05w = parcelRequire("eQ05w");

function $19ef7f856d9ae0a0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $19ef7f856d9ae0a0$var$embedCardWrapperStyles = {
    name: "yjftov",
    styles: "width:100%;height:100%;> div{height:100%;}.loader-wrapper{height:100%;}margin:0 auto"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
const $19ef7f856d9ae0a0$var$uIMediaSingleLayoutStyles = {
    name: "1abqfmo",
    styles: "margin-left:50%;transform:translateX(-50%)"
};
function $19ef7f856d9ae0a0$var$EmbedCardInternal(props) {
    const { url: url, data: data, eventHandlers: eventHandlers, layout: layout, width: width, isInsideOfBlockNode: isInsideOfBlockNode, rendererAppearance: rendererAppearance, smartLinks: smartLinks, isInsideOfInlineExtension: isInsideOfInlineExtension, onSetLinkTarget: onSetLinkTarget } = props;
    const portal = (0, $eauJy.usePortal)(props);
    const embedIframeRef = (0, $42omo.useRef)(null);
    const onClick = (0, $3jBhR.getCardClickHandler)(eventHandlers, url);
    const { actionOptions: actionOptions } = smartLinks || {};
    const platform = 'web';
    const cardProps = {
        url: url,
        onClick: onClick,
        container: portal,
        platform: platform,
        frameStyle: smartLinks?.frameStyle ?? 'show',
        actionOptions: actionOptions,
        CompetitorPrompt: smartLinks?.CompetitorPrompt
    };
    const [liveHeight, setLiveHeight] = (0, $42omo.useState)(null);
    const [aspectRatio, setAspectRatio] = (0, $42omo.useState)();
    const height = liveHeight || props.originalHeight;
    // We start with height and width defined with default values
    let originalHeight = (0, $aFUXX.DEFAULT_EMBED_CARD_HEIGHT);
    let originalWidth = (0, $aFUXX.DEFAULT_EMBED_CARD_WIDTH);
    // Then can override height and width with values from ADF if available
    if (props.originalHeight && props.originalWidth) {
        originalHeight = props.originalHeight;
        originalWidth = props.originalWidth;
    }
    // Then we can override it with aspectRatio that is comming from iframely via `resolve()`
    if (aspectRatio) {
        originalHeight = 1;
        originalWidth = aspectRatio;
    }
    // And finally if iframe sends live `height` events we use that as most precise measure.
    const isHeightOnlyMode = !(props.originalHeight && props.originalWidth) || liveHeight;
    if (height && isHeightOnlyMode) {
        originalHeight = height;
        originalWidth = undefined;
    }
    const padding = rendererAppearance === 'full-page' ? (0, $1zvWv.FullPagePadding) * 2 : 0;
    const [hasPreview, setPreviewAvailableState] = (0, $42omo.useState)(true);
    const cardContext = (0, $42omo.useContext)((0, $eIleF.SmartCardContext));
    const onResolve = ({ aspectRatio: resolvedAspectRatio })=>{
        const hasPreviewOnResolve = !!(cardContext && url && cardContext.extractors.getPreview(url, platform));
        if (!hasPreviewOnResolve) setPreviewAvailableState(false);
        setAspectRatio(resolvedAspectRatio);
    };
    const analyticsData = {
        attributes: {
            location: 'renderer'
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: 'renderer'
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bYRk6.default), {
        data: analyticsData
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bWRlG.WidthConsumer), null, ({ width: documentWidth })=>{
        const isFullWidth = rendererAppearance === 'full-width';
        let containerWidth = documentWidth;
        if (smartLinks?.ssr && !containerWidth) // EDM-8114: When we are rendering on SSR, we have no idea what the width is.
        containerWidth = isFullWidth ? (0, $aFUXX.akEditorFullWidthLayoutWidth) : (0, $aFUXX.akEditorDefaultLayoutWidth);
        let nonFullWidthSize = containerWidth;
        if (!isInsideOfBlockNode && rendererAppearance !== 'comment') {
            const isContainerSizeGreaterThanMaxFullPageWidth = containerWidth - padding >= (0, $aFUXX.akEditorDefaultLayoutWidth);
            if (isContainerSizeGreaterThanMaxFullPageWidth) nonFullWidthSize = (0, $aFUXX.akEditorDefaultLayoutWidth);
            else nonFullWidthSize = containerWidth - padding;
        }
        const lineLength = isFullWidth ? Math.min((0, $aFUXX.akEditorFullWidthLayoutWidth), containerWidth - padding) : nonFullWidthSize;
        const uiMediaSingleStyles = layout === 'full-width' || layout === 'wide' ? $19ef7f856d9ae0a0$var$uIMediaSingleLayoutStyles : '';
        const onError = ({ err: err })=>{
            if (err) throw err;
        };
        let cardComponent;
        if (smartLinks?.ssr && url && ((0, $dh538.fg)('platform_ssr_smartlink_embeds') || (0, $dh538.fg)('jfp-magma-ssr-iv-editor-links'))) {
            const ssrCardProps = {
                url: url,
                onClick: onClick,
                container: portal,
                platform: platform,
                frameStyle: smartLinks?.frameStyle ?? 'show',
                actionOptions: actionOptions
            };
            cardComponent = /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9CM6e.CardSSR), {
                appearance: "embed",
                ...ssrCardProps,
                onResolve: onResolve,
                inheritDimensions: true,
                embedIframeRef: embedIframeRef,
                onError: onError
            });
        } else cardComponent = /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hpUsb.Card), {
            appearance: "embed",
            ...cardProps,
            onResolve: onResolve,
            inheritDimensions: true,
            embedIframeRef: embedIframeRef,
            onError: onError
        });
        return(// Ignored via go/ees005
        /*#__PURE__*/ (0, $9K4OG.jsx)((0, $eIPRD.CardErrorBoundary), {
            unsupportedComponent: (0, $iq4lN.default),
            onSetLinkTarget: onSetLinkTarget,
            ...cardProps
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9ISlX.EmbedResizeMessageListener), {
            embedIframeRef: embedIframeRef,
            onHeightUpdate: setLiveHeight
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6CRn4.default), {
            css: uiMediaSingleStyles,
            layout: layout,
            width: originalWidth,
            containerWidth: containerWidth,
            pctWidth: width,
            height: originalHeight,
            fullWidthMode: isFullWidth,
            nodeType: "embedCard",
            lineLength: isInsideOfBlockNode ? containerWidth : lineLength,
            hasFallbackContainer: hasPreview,
            isInsideOfInlineExtension: isInsideOfInlineExtension
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $19ef7f856d9ae0a0$var$embedCardWrapperStyles
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "embedCardView-content-wrap",
            "data-embed-card": true,
            "data-layout": layout,
            "data-width": width,
            "data-card-data": data ? JSON.stringify(data) : undefined,
            "data-card-url": url,
            "data-card-original-height": originalHeight
        }, cardComponent))))));
    }));
}
const $19ef7f856d9ae0a0$export$1135f3b0aac4c4ec = ({ url: url, data: data, eventHandlers: eventHandlers, portal: portal, originalHeight: originalHeight, originalWidth: originalWidth, width: embedWidth, layout: layout, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, smartLinks: smartLinks, isInsideOfInlineExtension: isInsideOfInlineExtension, onSetLinkTarget: onSetLinkTarget })=>{
    const { width: width } = (0, $42omo.useContext)((0, $bWRlG.WidthContext));
    const viewAsBlockCard = width && width <= (0, $aFUXX.akEditorFullPageNarrowBreakout);
    return viewAsBlockCard ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $eQ05w.default), {
        url: url,
        data: data,
        eventHandlers: eventHandlers,
        portal: portal,
        layout: layout,
        rendererAppearance: rendererAppearance,
        smartLinks: smartLinks,
        onSetLinkTarget: onSetLinkTarget
    }) : /*#__PURE__*/ (0, $9K4OG.jsx)($19ef7f856d9ae0a0$var$EmbedCardInternal, {
        url: url,
        data: data,
        eventHandlers: eventHandlers,
        portal: portal,
        originalHeight: originalHeight,
        originalWidth: originalWidth,
        width: embedWidth,
        layout: layout,
        rendererAppearance: rendererAppearance,
        isInsideOfBlockNode: isInsideOfBlockNode,
        smartLinks: smartLinks,
        isInsideOfInlineExtension: isInsideOfInlineExtension,
        onSetLinkTarget: onSetLinkTarget
    });
};
const $19ef7f856d9ae0a0$var$EmbedCardWithCondition = (0, $9JpPs.componentWithCondition)(()=>(0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }), $19ef7f856d9ae0a0$export$1135f3b0aac4c4ec, $19ef7f856d9ae0a0$var$EmbedCardInternal);
var $19ef7f856d9ae0a0$export$2e2bcd8739ae039 = $19ef7f856d9ae0a0$var$EmbedCardWithCondition;
module.exports["default"] = $19ef7f856d9ae0a0$export$2e2bcd8739ae039;

});


//# sourceMappingURL=embedCard.834f1fd0.js.map
